/* KHUN CLUB · glosario: búsqueda y filtro por idioma de origen.
   Estado en la URL (?q=phi&idioma=tailandes). Oculta letras sin resultados. Sin JS se ve todo. */
(() => {
  const raiz = document.querySelector('[data-kc-glosario]');
  if (!raiz) return;

  const normalizar = (texto) =>
    String(texto ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

  const buscar = raiz.querySelector('[data-kc-glosario-q]');
  const conteo = raiz.querySelector('[data-kc-glosario-conteo]');
  const vacio = raiz.querySelector('[data-kc-glosario-vacio]');
  const radios = [...raiz.querySelectorAll('[name="idioma"]')];
  const grupos = [...raiz.querySelectorAll('[data-kc-glosario-grupo]')].map((grupo) => ({
    grupo,
    letra: raiz.querySelector(`[data-kc-glosario-letra="${grupo.dataset.kcGlosarioGrupo}"]`),
    items: [...grupo.querySelectorAll('.kc-glosario__item')].map((el) => ({
      el,
      idioma: el.dataset.idioma,
      // Busca en el término, la pronunciación y la definición que ya están en la página
      q: normalizar(el.textContent),
    })),
  }));
  const total = grupos.reduce((n, g) => n + g.items.length, 0);
  const idiomas = new Set(radios.map((r) => r.value));
  const estado = { q: '', idioma: '' };

  function leerURL() {
    const p = new URLSearchParams(location.search);
    estado.q = p.get('q') ?? '';
    estado.idioma = idiomas.has(p.get('idioma')) ? p.get('idioma') : '';
  }

  function escribirURL(nueva) {
    const p = new URLSearchParams();
    if (estado.q) p.set('q', estado.q);
    if (estado.idioma) p.set('idioma', estado.idioma);
    history[nueva ? 'pushState' : 'replaceState'](null, '', `${location.pathname}${p.toString() ? `?${p}` : ''}`);
  }

  function aplicar() {
    const terminos = normalizar(estado.q).split(/\s+/).filter(Boolean);
    let n = 0;
    for (const g of grupos) {
      let visibles = 0;
      for (const item of g.items) {
        const ok = terminos.every((t) => item.q.includes(t)) && (!estado.idioma || item.idioma === estado.idioma);
        item.el.hidden = !ok;
        if (ok) visibles += 1;
      }
      g.grupo.hidden = visibles === 0;
      if (g.letra) {
        if (visibles === 0) {
          g.letra.setAttribute('aria-disabled', 'true');
          g.letra.tabIndex = -1;
        } else {
          g.letra.removeAttribute('aria-disabled');
          g.letra.removeAttribute('tabindex');
        }
      }
      n += visibles;
    }
    const filtrado = terminos.length > 0 || estado.idioma;
    conteo.textContent = `${n} ${n === 1 ? 'término' : 'términos'}${filtrado ? ` de ${total}` : ''}`;
    vacio.hidden = n > 0;
    if (buscar.value.trim() !== estado.q) buscar.value = estado.q;
    radios.forEach((r) => (r.checked = r.value === estado.idioma));
  }

  let espera;
  buscar.addEventListener('input', () => {
    clearTimeout(espera);
    espera = setTimeout(() => {
      estado.q = buscar.value.trim();
      escribirURL(false);
      aplicar();
    }, 150);
  });

  radios.forEach((r) =>
    r.addEventListener('change', () => {
      estado.idioma = r.value;
      escribirURL(true);
      aplicar();
    }),
  );

  window.addEventListener('popstate', () => {
    leerURL();
    aplicar();
  });

  leerURL();
  aplicar();
})();
